// extracted by mini-css-extract-plugin
export default {"primaryCategoriesStack":"PrimaryCategoriesPage_primaryCategoriesStack__1CSi7"};